import { Position } from '../domain/Position';
/**
 * Команда для выполнения хода
 * Реализует паттерн Command для отмены/повтора ходов
 */
export class MoveCommand {
    sideId;
    from;
    to;
    round;
    moveInRound;
    timestamp;
    constructor(sideId, from, to, round, moveInRound, timestamp = new Date()) {
        this.sideId = sideId;
        this.from = from;
        this.to = to;
        this.round = round;
        this.moveInRound = moveInRound;
        this.timestamp = timestamp;
    }
    /**
     * Создаёт уникальный идентификатор команды
     */
    getId() {
        return `move-${this.sideId}-${this.round}-${this.moveInRound}-${this.timestamp.getTime()}`;
    }
    /**
     * Проверяет равенство команд
     */
    equals(other) {
        return (this.sideId === other.sideId &&
            this.from.equals(other.from) &&
            this.to.equals(other.to) &&
            this.round === other.round &&
            this.moveInRound === other.moveInRound);
    }
    /**
     * Сериализация команды
     */
    toJSON() {
        return {
            id: this.getId(),
            sideId: this.sideId,
            from: this.from.toString(),
            to: this.to.toString(),
            round: this.round,
            moveInRound: this.moveInRound,
            timestamp: this.timestamp.toISOString(),
        };
    }
    /**
     * Десериализация команды
     */
    static fromJSON(data) {
        const [fromX, fromY] = data['from']
            .replace(/[()]/g, '')
            .split(',')
            .map((s) => parseInt(s.trim()));
        const [toX, toY] = data['to']
            .replace(/[()]/g, '')
            .split(',')
            .map((s) => parseInt(s.trim()));
        return new MoveCommand(data['sideId'], new Position(fromX, fromY), new Position(toX, toY), data['round'], data['moveInRound'], new Date(data['timestamp']));
    }
    toString() {
        return `MoveCommand[side=${this.sideId}, from=${this.from}, to=${this.to}, round=${this.round}]`;
    }
}
//# sourceMappingURL=MoveCommand.js.map